module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};



// WEBPACK FOOTER //
// node_modules/_core-js@2.5.6@core-js/modules/_fails.js